import { IVideosState } from './videosContext';
import { VideosActionTypes, TVideosAction } from './videosActions';

export const videosReducer = (state: IVideosState, action: TVideosAction): IVideosState => {
	switch (action.type) {
		case VideosActionTypes.SET_VIDEOS:
			return {
				...state,
				videos: action.payload.videos,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case VideosActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case VideosActionTypes.SET_STUDIO:
			return {
				...state,
				selectedStudio: action.payload.selectedStudio,
				isUnassignedVideos: false,
				currentPage: 1,
			};
		case VideosActionTypes.SET_CATEGORY:
			return {
				...state,
				selectedCategory: action.payload.selectedCategory,
				isUnassignedVideos: false,
				currentPage: 1,
			};
		case VideosActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				selectedStudio: null,
				selectedCategory: null,
				isUnassignedVideos: false,
				currentPage: 1,
			};
		case VideosActionTypes.TOGGLE_UNASSIGNED_VIDEOS:
			return {
				...state,
				isUnassignedVideos: !state.isUnassignedVideos,
				currentPage: 1,
			};
		case VideosActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case VideosActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case VideosActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case VideosActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case VideosActionTypes.SET_ID_FOR_FULL_INFO:
			return {
				...state,
				IDForFullInfo: action.payload.IDForFullInfo,
			};
		case VideosActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case VideosActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
